<template>
  <div>
    <certificado-sidebar />
    <certificado-tabs-panel />
  </div>
</template>

<script>
import CertificadoSideBar from "@/components/bars/CertificadoSideBar";
import CertificadoTabsPanel from "@/components/reports_forms/CertificadoTabsPanel";

export default {
  name: "PaginaDeCertificado",

  components: {
    "certificado-sidebar": CertificadoSideBar,
    "certificado-tabs-panel": CertificadoTabsPanel,
  },
};
</script>

<style lang="scss" scoped></style>
